<template>
    <div class="py-4 container-fluid">
        <div v-if="!isLoading" class="row">
            <div class=" row">
                <div class="col-12">
                    <argon-alert v-if="showAlert" color="danger" :dismissible="true" @close-alert="closeAlert">
                        <strong>Alerta!</strong> Eliminada correctamente!
                    </argon-alert>
                    <alerts-table :alerts="alerts" />
                </div>
            </div>
        </div>
    </div>
</template>
  
<script>
import AlertsTable from "./components/AlertsTable.vue";
import ArgonAlert from "@/components/ArgonAlert.vue";

export default {
    name: "users",
    components: {
        AlertsTable,
        ArgonAlert
    },
    data() {
        return {
            isLoading: true,
            showAlert: false,
            alerts: undefined,
            // alerts: [
            //     {
            //         id: 1,
            //         user: {
            //             name: 'Luis Angel',
            //             last_name: 'Martinez Faz',
            //             rol: 'Administrador',
            //             phone: '4444231264',
            //             email: 'luis.martinezgaz@gmail.com'
            //         },
            //         description: `Choque con trailer, todos muertos alv!`,
            //         date: new Date().toISOString(),
            //         status: 1, //1 - NUEVO   2  - EN CURSO   3 - RESUELTO  4 - CANCELADO/ELIMINADO/IGNORADO
            //         lat: '22.119417',
            //         lng: '-101.029418',
            //     },
            //      {
            //         id: 2,
            //         user: {
            //             name: 'Pedro Angel',
            //             last_name: 'Martinez Faz',
            //             rol: 'Administrador',
            //             phone: '4444231264',
            //             email: 'luis.martinezgaz@gmail.com'
            //         },
            //         description: ``,
            //         date: new Date().toISOString(),
            //         status: 2, //1 - NUEVO   2  - EN CURSO   3 - RESUELTO  4 - CANCELADO/ELIMINADO/IGNORADO
            //         lat: '37.91058523562196',
            //         lng: '-107.51591093115218',
            //     },
            //      {
            //         id: 3,
            //         user: {
            //             name: 'Luis Angel',
            //             last_name: 'Martinez Faz',
            //             rol: 'Administrador',
            //             phone: '4444231264',
            //             email: 'luis.martinezgaz@gmail.com'
            //         },
            //         description: ``,
            //         date: new Date().toISOString(),
            //         status: 3, //1 - NUEVO   2  - EN CURSO   3 - RESUELTO  4 - CANCELADO/ELIMINADO/IGNORADO
            //         lat: '22.119417',
            //         lng: '-103.029418',
            //     },           
            //      {
            //         id: 4,
            //         user: {
            //             name: 'Luis Angel',
            //             last_name: 'Martinez Faz',
            //             rol: 'Administrador',
            //             phone: '4444231264',
            //             email: 'luis.martinezgaz@gmail.com'
            //         },
            //         description: ``,
            //         date: new Date().toISOString(),
            //         status: 4, //1 - NUEVO   2  - EN CURSO   3 - RESUELTO  4 - CANCELADO/ELIMINADO/IGNORADO
            //         lat: '22.119417',
            //         lng: '-103.029418',
            //     },                
            // ]
        };
    },
    created() {
        this.plain
            .get(`/alerts`)
            .then((response) => {
                if (response.data.length !== 0) this.alerts = response.data;
                else this.alerts = [];
                this.isLoading = false;
            })
            .catch((err) => {
                this.alerts = [];
                this.isLoading = false;
                console.log(err);
            });
    },
    methods: {
        closeAlert() {
            this.showAlert = false;
        },
        refreshAlerts(){
            this.isLoading = true
            this.plain
            .get(`/alerts`)
            .then((response) => {
                if (response.data.length !== 0) this.alerts = response.data;
                else this.alerts = [];
                this.isLoading = false;
            })
            .catch((err) => {
                this.alerts = [];
                this.isLoading = false;
                console.log(err);
            });
        }
    },
};
</script>

  